import ReturnHeaderMeta from "@dana/Components/StandardReturns/ReturnHeaderMeta";

import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { SystemListValuesModel } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";

import Select from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// --- Props Interface ---
interface StepReasonDispositionProps {
    setReason: (r?: any) => void;
    setDisposition: (d?: any) => void;
}

// --- Styles Interfaces and Objects ---
export interface StepReasonDispositionStyles {
    wrapper?: InjectableCss;
    section?: InjectableCss;
    sectionTitle?: TypographyPresentationProps;
    description?: TypographyPresentationProps;
}

export const StepReasonDispositionStyles: StepReasonDispositionStyles = {
    section: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    sectionTitle: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    description: {
        css: css`
            margin-bottom: 16px;
        `,
    },
};

const styles = StepReasonDispositionStyles;
const mapStateToProps = (state: ApplicationStateDana) => {
    return {
        reason: state.standardReturnState?.reason,
        disposition: state.standardReturnState?.disposition,
        standardReturnReasons: state.standardReturnState?.standardReturnReasons,
        dispositionPreferences: state.standardReturnState?.dispositionPreferences,
    };
};
type Props = ReturnType<typeof mapStateToProps> & StepReasonDispositionProps;

// --- Component Definition ---
const StepReasonDisposition: FC<Props> = ({
    reason,
    disposition,
    setReason,
    setDisposition,
    standardReturnReasons,
    dispositionPreferences,
}) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <ReturnHeaderMeta />
            <StyledWrapper {...styles.section} className="return-reason">
                <Typography variant="h3" {...styles.sectionTitle}>
                    {translate("Reason for return")}
                </Typography>
                <Typography as="p" {...styles.description}>
                    {translate(
                        `Selecting the most accurate reason for your return helps us gather essential feedback, that enables us to continuously improve our services and product quality. If your option is not listed below, use the "support" feature`,
                    )}
                </Typography>
                <Select value={reason || ""} onChange={e => setReason(e.target.value || undefined)}>
                    <option value="">{translate("Select")}</option>
                    {standardReturnReasons?.map((reason: SystemListValuesModel) => (
                        <option key={reason?.id} value={reason?.name}>
                            {translate(reason?.description)}
                        </option>
                    ))}
                </Select>
            </StyledWrapper>
            <StyledWrapper {...styles.section} className="disposition-preference">
                <Typography variant="h3" {...styles.sectionTitle}>
                    {translate("Choose Disposition Preference")}
                </Typography>
                <Typography as="p" {...styles.description}>
                    {translate(
                        `If any of these parts are deemed non-refundable for credit (not on the RMA, damaged, rusted, nicks, etc.) please indicate your disposition preference`,
                    )}
                </Typography>
                <Select value={disposition || ""} onChange={e => setDisposition(e.target.value || undefined)}>
                    <option value="">{translate("Select")}</option>
                    {dispositionPreferences?.map((dispositionPreference: SystemListValuesModel) => (
                        <option key={dispositionPreference?.id} value={dispositionPreference?.name}>
                            {translate(dispositionPreference?.description)}
                        </option>
                    ))}
                </Select>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(StepReasonDisposition);
